export default "__VITE_ASSET__z2Wt2z0P__"